import { render, staticRenderFns } from "./WidgetConfig.vue?vue&type=template&id=6c8a5086&scoped=true&"
import script from "./WidgetConfig.vue?vue&type=script&lang=js&"
export * from "./WidgetConfig.vue?vue&type=script&lang=js&"
import style0 from "./WidgetConfig.vue?vue&type=style&index=0&id=6c8a5086&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8a5086",
  null
  
)

export default component.exports